import { stringify } from 'qs';
import { Verticals } from './verticals.enum';

export const excludedVerticals = stringify({ excludeVerticals: [Verticals.ORDER_AHEAD, Verticals.SERVICE_BOOKING] });
